import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Store } from 'src/app/core/store/store';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from '../../../services/dashboard.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { EventsService } from 'src/app/shared/services/events.service';
@Component({
  selector: 'app-course-level-feedback-form',
  templateUrl: './course-level-feedback-form.component.html',
  styleUrls: ['./course-level-feedback-form.component.css']
})
export class CourseLevelFeedbackFormComponent implements OnInit {
  activationData;
  user;
  @ViewChild('feedbackForm') feedbackForm: NgForm;
  stars: number[] = [1, 2, 3, 4, 5];
  feedback = {
    isStandloneCoureFeedback:false,
    rating: 0,
    courseLearning: '',
    courseCaseStudies: '',
    exercisesHelped:'',
    coursetUsefull: {
      elements: [],
      otherText: '',
    },
    significantlyImproved:'',
    testimonial:false
  };
  title;
  programData: any;
  constructor(private dashboardService: DashboardService,private store: Store,private toaster: ToastrService, private cs: CommonService, private eventsService: EventsService) {
    
   }

  ngOnInit(): void {
    this.dashboardService.getProgramActivation().subscribe(
      (res: any) => {
        this.activationData = res['data'];
        for (let i = 0; i < this.activationData[0].program.dashboard.length; i++) {
          if (this.activationData[0].program.dashboard[i].type === 'COURSE') {
            this.title = this.activationData[0].program.dashboard[i].title;
          }
        }
      })
      this.store.select('user').subscribe((user: any) => {
        this.user = user;
      })
  }
  startClicked(num) {
    if (num) {
      this.feedback.rating = num;
      //this.feedbackForm.get('rating').patchValue(num);
    }
  }
  selectElement(value) {
    let index;
    if (value) {
      index = this.feedback.coursetUsefull.elements.findIndex(v => v == value);
      if (index != -1) {
        this.feedback.coursetUsefull.elements.splice(index, 1);
        return;
      }
      this.feedback.coursetUsefull.elements.push(value)
    }
  }
  submit() {
    let data;
    if (!this.feedback.rating || !this.feedback.courseLearning || !this.feedback.courseCaseStudies || !this.feedback.exercisesHelped || !this.feedback.coursetUsefull) {
      this.toaster.warning("Please fill all mandatory fields");
      return;
    } else {
      this.feedback.isStandloneCoureFeedback = true;
      data = {
        programActivationId: this.activationData[0].programActivationId,
        feedback: this.feedback,
      }
      this.dashboardService.saveProgramFeedback(data).subscribe((res) => {
        if (res) {
          this.toaster.success("Course feedback submitted successfully");
          this.cs.reloadRoute('/dashboard');
          // this.getProgramActivation();
          // capture event program feedback
          try {   
            if(this.user && this.activationData && this.activationData.length && this.feedback){
              let eventData = { 'feedback': this.feedback, 'user': this.user, 'activationData': this.activationData[0] }
              this.eventsService.programFeedbackEvent(eventData);
            }
          } catch (err) {
            console.log(err);  
          }
        }
      })
    }
  }
  getProgramActivation() {
    this.dashboardService.getProgramActivation().subscribe((res) => {
      if (res && res['data']) {
        this.store.set('courseStart', null);
        this.store.set('zoomStart', null);
        this.store.set('activation', res['data']);
      }
    });
  }
}
